<template>
  <div class="Banner">
    <section
      class="relative w-full overflow-hidden group"
      @mouseenter="stopAutoPlay"
      @mouseleave="startAutoPlay"
    >
      <div class="relative w-full" :style="{ paddingTop: aspectRatio + '%' }">
        <transition-group tag="div" name="fade">
          <div
            v-for="(slide, index) in slides"
            v-show="currentSlide === index"
            :key="slide.tag"
            class="absolute inset-0"
          >
            <div class="absolute inset-0 z-0">
              <img
                :src="slide.img"
                :alt="slide.title"
                class="w-full h-full object-cover shadow-inner"
              />
            </div>
          </div>
        </transition-group>
      </div>

      <button
        @click="prevSlide"
        class="absolute left-2 md:left-6 top-1/2 -translate-y-1/2 z-20 w-8 h-8 md:w-12 md:h-12 rounded-full bg-white/10 hover:bg-primary backdrop-blur-md border border-white/30 text-white transition-all flex items-center justify-center opacity-0 group-hover:opacity-100"
      >
        <span class="material-symbols-outlined text-lg md:text-2xl"
          >chevron_left</span
        >
      </button>
      <button
        @click="nextSlide"
        class="absolute right-2 md:right-6 top-1/2 -translate-y-1/2 z-20 w-8 h-8 md:w-12 md:h-12 rounded-full bg-white/10 hover:bg-primary backdrop-blur-md border border-white/30 text-white transition-all flex items-center justify-center opacity-0 group-hover:opacity-100"
      >
        <span class="material-symbols-outlined text-lg md:text-2xl"
          >chevron_right</span
        >
      </button>

      <div
        class="absolute bottom-4 md:bottom-8 left-1/2 -translate-x-1/2 z-20 flex gap-2 md:gap-3"
      >
        <button
          v-for="(_, index) in slides"
          :key="index"
          @click="goToSlide(index)"
          :class="[
            currentSlide === index
              ? 'w-6 md:w-12 bg-primary'
              : 'w-2 md:w-3 bg-white/50 hover:bg-white'
          ]"
          class="h-1.5 rounded-full transition-all duration-500 ease-in-out"
          :aria-label="'Go to slide ' + (index + 1)"
        ></button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Template',
  components: {},
  data() {
    return {
      currentSlide: 0,
      autoPlayTimer: null,
      aspectRatio: 40, // 默认16:9的比例(56.25%)
      // 模拟网络图片数据
      slides: [
        {
          tag: 'Premium Manufacturer',
          title:
            "Custom Craft & <br/><span class='text-primary'>Metal Gifts</span>",
          subtitle: '18+ Years Professional Excellence since 2004',
          img: require('@/assets/banner01.jpg')
        },
        {
          tag: 'Advanced Workshop',
          title:
            "Precision CNC <br/><span class='text-primary'>& Engraving</span>",
          subtitle: 'State-of-the-art technology for every detail',
          img: require('@/assets/banner02.jpg')
        },
        {
          tag: 'Global Supply',
          title:
            "Trusted by <br/><span class='text-primary'>Global Brands</span>",
          subtitle: 'SGS & Sedex Certified Manufacturing',
          img: require('@/assets/banner03.jpg')
        }
      ]
    }
  },
  mounted() {
    this.startAutoPlay()
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.slides.length
    },
    prevSlide() {
      this.currentSlide =
        (this.currentSlide - 1 + this.slides.length) % this.slides.length
    },
    goToSlide(index) {
      this.currentSlide = index
    },
    startAutoPlay() {
      if (!this.autoPlayTimer) {
        this.autoPlayTimer = setInterval(this.nextSlide, 5000)
      }
    },
    stopAutoPlay() {
      clearInterval(this.autoPlayTimer)
      this.autoPlayTimer = null
    }
  }
}
</script>

<style scoped>
/* 字体设置 */
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&display=swap');

.font-serif {
  font-family: 'Playfair Display', serif;
}

/* 幻灯片淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* 微动动画：让 Tag 更有活力 */
.animate-bounce-subtle {
  animation: bounce-subtle 2s infinite;
}

@keyframes bounce-subtle {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}
</style>



// WEBPACK FOOTER //
// src/page/index/BannerSection.vue